import { BackendApi } from '../api/api.ts';
import { QueryKey } from '../api/queryKeys.ts';
import { usePartner__getFixedAssetDetails } from '../generated/blueprint.ts';

const api = new BackendApi();

export function useFixedAssetDetails(businessId: string | null, fixedAssetId: string | null) {
    return usePartner__getFixedAssetDetails(
        api,
        { client_business_id: businessId ?? '', fixed_asset_id: fixedAssetId ?? '', as_of: null },
        { queryKey: QueryKey.FixedAssets, enabled: !!businessId && !!fixedAssetId },
    );
}
